import Checkbox from '@mui/material/Checkbox'
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel'
import { Controller, useFormContext } from 'react-hook-form'
import type { Theme, SxProps } from '@mui/material/styles'
import type { CheckboxProps } from '@mui/material/Checkbox'
import type { FormHelperTextProps } from '@mui/material/FormHelperText'
import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'

type RHFCheckboxProps = Omit<FormControlLabelProps, 'control'> & {
  name: string
  helperText?: React.ReactNode
  slotProps?: {
    wrap?: SxProps<Theme>
    checkbox?: CheckboxProps
    formHelperText?: FormHelperTextProps
  }
}

export function RHFCheckbox({ name, helperText, label, slotProps, ...other }: RHFCheckboxProps) {
  const { control } = useFormContext()

  const ariaLabel = `Checkbox ${name}`

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box sx={slotProps?.wrap}>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                {...slotProps?.checkbox}
                inputProps={{
                  ...(!label && { 'aria-label': ariaLabel }),
                  ...slotProps?.checkbox?.inputProps
                }}
              />
            }
            label={label}
            {...other}
          />

          {(!!error || helperText) && (
            <FormHelperText error={!!error} {...slotProps?.formHelperText}>
              {error ? error?.message : helperText}
            </FormHelperText>
          )}
        </Box>
      )}
    />
  )
}
